export enum DatabaseUserStatus {
  CREATING,
  CREATED,
  ERROR,
}

export enum DatabaseStatus {
  IN_PROGRESS,
  DONE,
  ERROR,
  ACTIVE,
  DISABLED,
  DELETING,
}

export interface DatabaseLog {
  id: number;
  log: string;
}

export interface DatabaseUserLog {
  id: number;
  log: string;
}

export interface Database {
  id: number;
  name: string;
  websiteId: number;
  size: number;
  server: string;
  status: DatabaseStatus;
  users: DatabaseUser[];
  logs: DatabaseLog[];
}

export interface DatabaseUser {
  id: number;
  username: string;
  status: DatabaseUserStatus;
  databases: Database[];
  logs: DatabaseUserLog[];
  unixUser?: { id: number; unixUserId: number };
}

export interface DatabaseCreate {
  name: string;
  server: string;
  websiteId: number;
  password: string;
  passwordConf: string;
}

export interface DatabaseUserCreate {
  username: string;
  password: string;
  passwordConf: string;
  databaseId: number;
}

export interface DatabaseUserEdit {
  password: string;
  passwordConf: string;
  databaseId: number;
}

export interface ViewDatabaseUserDialogComponentData {
  databaseUser: DatabaseUser;
}

export interface DatabaseRecord extends Database {
  serverHostname?: string;
  websiteDomain?: string;
}

export interface DatabaseUserRecord extends DatabaseUser {
  websiteDomains: string[];
  serverHostname: string;
}
